import fetchHandler, { fetchHandlerForm } from './Handler';

// import { Category } from '../../types/cards';

export const addContacts = async (body: FormData): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'POST',
			endpoint: 'admin/product',
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getAllContacts = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/contactus', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

export const deleteContacts = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/contactus/${data}`,
		});
		// if (response) {
		// return await getAllProducts();
		// }
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

// =======================================================
export const updateContacts = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/contactus/${id}`,
			data,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const updateCategoryStatus = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `category/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const getSingleCategory = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `category/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const updateWholesale = async (body: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `admin/wholesale/${id}`,
			body,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
